"use client";

import { c as _c } from "react/compiler-runtime";
import { IntegrationGuidesGrid } from "@llmgateway/shared/components";
export function GuidesGrid(t0) {
  const $ = _c(2);
  const {
    uiUrl
  } = t0;
  let t1;
  if ($[0] !== uiUrl) {
    t1 = <IntegrationGuidesGrid internalHrefPrefix={uiUrl} />;
    $[0] = uiUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}